// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QU1p","right":"styles_right__16PC8"};